'use client';

import RecaptchaWrapper from "@/components/common/recaptcha/recaptcha_wrapper";
import { isRecaptchaPage } from "@/functions/is_recaptcha_page";
import useGoogleOneTap from "@/hooks/one_tap_auth";
import { useConsent } from "@/providers/consent-context";
import { getRecaptchaPages } from "@/variables/variables";
import { SessionProvider } from "next-auth/react";
import { useEffect } from "react";
import { clearAuthCookiesOnVersionChange } from "@/functions/check_app_version";
import { AuthContextProvider } from '@/providers/auth-context';
import { MobileAppProvider, useMobileApp } from '@/providers/mobile-app-context';
import dynamic from 'next/dynamic';
import PublicHeader from "@/components/public_header/public_header";
import NativeContentWrapper from '@/components/mobile/native_content_wrapper';
import StorageSessionGuard from '@/components/common/storage_session_guard';
import LongTaskMonitor from '@/components/common/long_task_monitor';
import ErrorQueueRetry from '@/components/common/error_queue_retry';
import SocialAuthTracker from '@/components/common/analytics/social_auth_tracker';
import SurveyDrawerManager from '@/components/common/survey_drawer/survey_drawer_manager';

const recaptcha_pages = getRecaptchaPages();
const MobileBottomTabBar = dynamic(() => import('@/components/mobile/mobile_bottom_tab_bar'), { ssr: false });
const MobileOfflineState = dynamic(() => import('@/components/mobile/mobile_offline_state'), { ssr: false });

export default function LayoutWrapper({ children, overlays = null, runtimePath = '' }) {
    useEffect(() => {
        //if(window.deviceToken) axios.defaults.headers.common['deviceToken'] = window.deviceToken;

        // Docker restart esetén auth cookie-k törlése (verzió alapú detekció)
        clearAuthCookiesOnVersionChange();
    }, [])

    let is_recaptcha = isRecaptchaPage(recaptcha_pages, runtimePath);

    let content = <SessionProvider>
        <CallOneTap>
            <AuthContextProvider>
                <MobileAppProvider>
                    <div className='main'>
                        <StorageSessionGuard />
                        <LongTaskMonitor />
                        <ErrorQueueRetry />
                        <PublicHeader />
                        <SurveyDrawerManager />
                        <NativeContentWrapper routeKey={runtimePath}>
                            {children}
                        </NativeContentWrapper>
                        <SocialAuthTracker />
                        <MobileBottomTabBarSlot />
                        <MobileOfflineStateSlot />
                        {overlays}
                    </div>
                </MobileAppProvider>
            </AuthContextProvider>
        </CallOneTap>
    </SessionProvider>

    if(is_recaptcha) return <RecaptchaWrapper>
        {content}
    </RecaptchaWrapper>

    return content;
}

function MobileBottomTabBarSlot() {
    const { isNativeApp } = useMobileApp();

    return isNativeApp ? <MobileBottomTabBar /> : null;
}

function MobileOfflineStateSlot() {
    const { isNativeApp } = useMobileApp();

    return isNativeApp ? <MobileOfflineState /> : null;
}

function CallOneTap({children}) {
    const { canUseIntegration } = useConsent();
    const canUseGoogleOneTap = canUseIntegration('googleOneTap');

    useGoogleOneTap(canUseGoogleOneTap);

    return <>
        {children}
    </>
}